import { error, finish } from '../../../modules/ladders/actions/get-list';
import api from '../../../api';

export function request(dispatch) {
    // api.get(`/ladders`, void 0, { cache: true }).then(
    //     data => dispatch(finish(data)),
    //     ({ errors }) => dispatch(error(errors))
    // );

    $appState.sdkStaff.trading.getAllPriceLadders()
        .then(data => dispatch(finish(data)))
        .catch(errors => dispatch(error(errors)));
}
